import isArray from './is-array';
import isString from './is-string';

function startsWith(arr, e) {
  return isArray(arr) || isString(arr) ? arr[0] === e : false;
}

export default startsWith;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/starts-with.js
// module id = 49
// module chunks = 0